import { createFileRoute } from '@tanstack/react-router';
import CollectionUsagePage from '@/pages/workspaces/journeys/collections/[collectionId]/usage.page';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import { LazyPage } from './-route-layouts';

function CollectionUsageRoute() {
  return (
    <LazyPage>
      <RumPageRendered>
        <CollectionUsagePage />
      </RumPageRendered>
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/collections/$collectionId/usage')({
  component: CollectionUsageRoute,
});
